import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        beforeEnter: (to, from, next) => {
            if (Vue.storage.get('sessionId', null) !== null) {
                return store.dispatch('load').then(
                    account => { next({ name: 'dashboard' }) },
                    () => {
                        let dest = null
                        if (to.fullPath.substr(0, 5) === '/env/') {
                            dest = to.fullPath
                        }
                        next({ name: 'login', query: { next: dest } })
                    }
                )
            }
            next({ name: 'login' })
        }
    },
    {
        path: '/auth',
        component: () => import(/* webpackChunkName: "Auth" */ '@/views/Interfaces/UnauthInterface'),
        redirect: { name: 'login' },
        children: [
            {
                path: 'login',
                name: 'login',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "Auth" */ '@/views/auth/Login')
            },
            {
                path: 'lost-password',
                name: 'lost-password',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "Auth" */ '@/views/auth/LostPassword')
            },
            {
                path: 'session/:token', // When requesting a one-time login link
                name: 'one-time-login',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "Auth" */ '@/views/auth/ResetPassword')
            },
            {
                path: 'verify/:token', // When creating a new account.
                name: 'email-verify',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "Auth" */ '@/views/auth/ResetPassword')
            },
            {
                path: 'password-reset/:token', // When requested a password reset
                name: 'reset-password',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "Auth" */ '@/views/auth/ResetPassword')
            }
        ]
    },
    {
        path: '/env',
        component: () => import(/* webpackChunkName: "Manager" */ '@/views/Interfaces/Interface'),
        redirect: { name: 'dashboard' },
        children: [
            {
                path: '',
                name: 'dashboard',
                component: () => import(/* webpackChunkName: "Manager" */ '@/views/Dashboard')
            },
            {
                path: 'logs',
                name: 'logs',
                component: () => import(/* webpackChunkName: "Manager" */ '@/views/Logs')
            },
            {
                path: 'apikeys',
                name: 'apikeys',
                component: () => import(/* webpackChunkName: "Manager" */ '@/views/ApiKeys')
            },
            {
                path: 'billing',
                name: 'billing',
                component: () => import(/* webpackChunkName: "Manager" */ '@/views/Billing')
            },
            {
                path: 'invoices',
                name: 'invoices',
                component: () => import(/* webpackChunkName: "Manager" */ '@/views/Invoices')
            },
            {
                path: 'settings',
                name: 'settings',
                component: () => import(/* webpackChunkName: "Manager" */ '@/views/Settings')
            }
        ]
    },
    {
        path: '/upgrade',
        redirect: { name: 'upgrade' },
        component: () => import(/* webpackChunkName: "Upgrade" */ '@/views/upgrade/UpgradeInterface'),
        beforeEnter: (to, from, next) => {
            if (to.meta.steps > 1) {
                if (!to.query.plan) {
                    next({ name: 'upgrade' })
                    return false
                }
            }
            next()
        },
        children: [
            {
                path: 'plans',
                name: 'upgrade',
                component: () => import(/* webpackChunkName: "Upgrade" */ '@/views/upgrade/Plans'),
                meta: { steps: 1 }
            },
            {
                path: 'settings',
                name: 'upgrade-settings',
                component: () => import(/* webpackChunkName: "Upgrade" */ '@/views/upgrade/Settings'),
                meta: { steps: 2 }
            },
            {
                path: 'payment',
                name: 'upgrade-payment',
                component: () => import(/* webpackChunkName: "Upgrade" */ '@/views/upgrade/Payment'),
                meta: { steps: 3 }
            },
            {
                path: 'success',
                name: 'upgrade-success',
                component: () => import(/* webpackChunkName: "Upgrade" */ '@/views/upgrade/Success'),
                meta: { steps: 4 }
            }
        ]
    },
    {
        path: '/pay/:invoiceId',
        name: 'pay',
        component: () => import('@/views/Pay')
    }
]

const router = new VueRouter({
    mode: 'history',
    linkActiveClass: 'active',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (to.meta.basename) {
            return
        }

        if (to.name === 'logs') {
            return
        }

        return { x: 0, y: 0 }
    }
})

export default router
